

// Internal Imports

/** ========================================================================
 * * LoadingCard Component
 * This component renders a card that is used as placeholder for loading.
 * ========================================================================== */

export default function LoadingCard({ columns = 4, max = 1 }) {
  /* ======================  CLASSNAMES ====================== */
  const classNames = () => {
    let classes = "grid gap-4 p-4 rounded-md lg:grid-cols-5 border border-stone-600";
    if (columns)
      classes = classes.replace(
        "lg:grid-cols-5",
        `lg:grid-cols-${columns}`
      );
    return classes;
  };

  // Random Number less than max
  const random = () => Math.floor(Math.random() * max) + 1;

  return (
    <div className="min-h-[90vh] lg:min-h-0">
      {Array.from({ length: random() }).map((_, idx) => (
        <div key={idx} className={classNames()}>
          <div className="h-10 rounded animate-pulse bg-stone-800"></div>
          {Array.from({ length: columns - 1 }).map((_, idx) => (
            <div
              key={idx}
              className="hidden h-10 rounded animate-pulse bg-stone-700 lg:block"
            ></div>
          ))}
        </div>
      ))}
    </div>
  );
}
